import { ArrowRight } from 'lucide-react'
import { HashLink } from 'react-router-hash-link'

type BaseGhostButtonProps = {
    text: string
    url: string
    classProps?: string
}
export default function BaseGhostButton(props:BaseGhostButtonProps) {
  return (
     <HashLink
            to={props.url}
            className={`flex items-center gap-2 w-fit text-primary font-text font-bold text-sm hover:text-secondary transition-colors duration-200 group ${props.classProps || ''}`}
          >
            {props.text}
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
          </HashLink>
  )
}
